const OTP_PATTERN = /^[1-9]\d{5}$/;

export const normalizeOTPInput = (value: string): string =>
  value.replace(/\D/g, '').slice(0, 6);

export const parseOTP = (value: string): number | undefined =>
  OTP_PATTERN.test(value) ? Number(value) : undefined;
